module.exports = __webpack_public_path__ + "7951d353f64407ddc06b4252940345d9.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/old-way.png
// module id = 697
// module chunks = 0